var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchaseFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.49979 6.99905V13.1271C7.52979 13.3604 7.4548 13.6093 7.28232 13.7726C7.21295 13.8447 7.13054 13.9019 7.03982 13.9409C6.94911 13.9799 6.85186 14 6.75364 14C6.65543 14 6.55818 13.9799 6.46747 13.9409C6.37675 13.9019 6.29434 13.8447 6.22497 13.7726L4.71768 12.2095C4.63589 12.1265 4.5737 12.0251 4.53598 11.9132C4.49825 11.8012 4.48601 11.6817 4.50021 11.564V6.99905H4.47771L0.158309 1.25983C0.0365318 1.09771 -0.0184164 0.892191 0.00547091 0.688185C0.0293582 0.48418 0.130139 0.298273 0.285791 0.171088C0.428271 0.0622138 0.58575 0 0.750727 0H11.2493C11.4142 0 11.5717 0.0622138 11.7142 0.171088C11.8699 0.298273 11.9706 0.48418 11.9945 0.688185C12.0184 0.892191 11.9635 1.09771 11.8417 1.25983L7.52229 6.99905H7.49979Z",
    fill: "#E4E4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseFilter);
export default __webpack_public_path__ + "static/media/purchase-filter.4171a9d3a77b0ea01a0c352912cd4fe4.svg";
export { ForwardRef as ReactComponent };